import { mask } from 'remask';

export const maskAddressNumber = (value: string) => {
  if (value === '' || value === undefined || value === null) return '';

  const number = ['99999'];

  return mask(value, number);
};
